export default function() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-quadtree/src/data.js
// module id = 350
// module chunks = 0 1 2 3 4